export default __webpack_public_path__ + "static/matrix-logo-fa747010865f86a7017e5a79e2e4c00e.svg";